<template lang="pug">
  div
    TextBox(
      :error-messages="errors.first_name",
      :label="$t('form.profile.profile.first_name')",
      :value.sync="profileForm.first_name",
      @update:value="clearError('first_name')",
    )
    TextBox(
      :error-messages="errors.last_name",
      :label="$t('form.profile.profile.last_name')",
      :value.sync="profileForm.last_name",
      @update:value="clearError('last_name')",
    )
    TextBox(
      :error-messages="errors.email",
      :label="$t('form.profile.profile.email')",
      :required="false",
      :value.sync="profileForm.email",
      @update:value="clearError('email')",
    )

    Phone(
      :country="country",
      :enable-extension="isSuperadmin",
      :error-messages="errors.mobile",
      :extension-label="$t('form.profile.profile.extension')",
      :label="$t('form.profile.profile.mobile_number')",
      :value.sync="profileForm.mobile",
      @update:value="clearError('mobile')",
      @update:country="country = $event",
    )

    v-row(no-gutters)
      .flex-grow-1
      v-btn.mt-4(
      color="primary",
      :disabled="hasError || !valid",
      :ripple="false",
      :loading="isLoading",
      @click="wrapProgress(submit)",
    ) {{ $t("form.profile.profile.update") }}
</template>

<script>
import { keys, mergeAll, mergeRight, pick } from 'ramda';
import { formHelper } from '@/config/mixins';
import {
  findCountry,
  addExtensionCode,
  stripExtensionCode,
} from '@/utils/helper';

export default {
  mixins: [formHelper],

  data() {
    return {
      profileForm: {},
      country: null,
    };
  },

  created() {
    this.country = findCountry(this.authUser.mobile);
    this.profileForm = mergeAll([
      this.model,
      this.authUser,
      {
        mobile: stripExtensionCode(this.authUser.mobile),
      },
    ]);
  },

  methods: {
    submit() {
      if (this.validate()) {
        const payload = pick(
          keys(this.model),
          mergeRight(this.profileForm, {
            mobile: addExtensionCode(this.country, this.profileForm.mobile),
          }),
        );

        this.wrapProgress(() =>
          this.$store
            .dispatch(`auth/updateProfile`, payload, {
              root: true,
            })
            .catch(this.setError),
        );
      }
    },
  },
};
</script>
